import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import DarkModeBtn from '../components/DarkModeBtn';
import SidebarSteps from '../components/SidebarSteps';
// import useAuthRedirect from '../hooks/useAuthRedirect';
function SignUp2() {
   // useAuthRedirect();
   const navigate = useNavigate();
   const [message, setMessage] = useState('');
   const simulateValidation = async () => {
      const token = localStorage.getItem('demoToken');
      const userEmail = localStorage.getItem('userEmail');
      if (!token || !userEmail) {
         setMessage('Token or email not found. Please register first.');
         return;
      }
      try {
         const response = await fetch(`https://pt-api.digit-a.net/api/validation-link/validate/${token}`, {
            method: 'GET',
            headers: {
               'Content-Type': 'application/json',
            },
         });
         const data = await response.json();
         console.log('Validation response:', data);
         if (data.payload && data.payload.validated) {
            // Verifica que el correo en la respuesta coincida con userEmail
            if (data.payload.email !== userEmail) {
               setMessage('The email address in the JWT does not match the one registered. Please restart the process..');
               return;
            }
            localStorage.setItem('jwt', data.payload.jwt);
            navigate('/sign-up-3');
         } else {
            setMessage('Validation error. Please try again..');
         }
      } catch (error) {
         console.error('Error:', error);
         setMessage('Connection error. Please try again.');
      }
   };
   return (
      <div className="container" page-key="signup2">
         <div className="row">
            <div className="col-12 d-flex justify-content-between justify-content-lg-end mb-4 align-items-center ">
               <span className="mt-auto d-lg-none">
                  <img src={process.env.PUBLIC_URL + '/assets/img/logo_propert.svg'} data-lightmodeimg alt="ProperT" border="0" />
               </span>
               <DarkModeBtn />
            </div>
            <div className="col-12">
               <div className="d-flex flex-column align-items-center align-items-lg-start w-100 gap-2 mb-3">
                  <h1 className="d-lg-none">Sign Up</h1>
                  <SidebarSteps activeStep={2} />
               </div>
               <div className="ppt_signup_steps">
                  <div className="ppt_signup_steps_info text-center">
                     <img src={process.env.PUBLIC_URL + '/assets/img/icon_email.svg'} data-lightmodeimg className="smallMeicon img-fluid mb-4" alt="" />
                     <h3 className="ppt_form_title mb-0">Email confirmation</h3>
                     <p className="fs-5 mb-4">Please check you email to confirm.</p>
                     {message && <p className="text-danger mb-4">{message}</p>}
                     <div className="d-flex flex-column gap-3 align-items-center">
                        <button onClick={simulateValidation} className="ppt_btn_primary">
                           Simulate Validation
                        </button>
                        <NavLink to="." className="text-decoration-underline">Resend</NavLink>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
}
export default SignUp2;